import { FC } from 'react';
import classnames from 'classnames';

import HeartFilled from './HeartFilled';

import styles from './styles/LikeHeartIcon.scss';

type LikeHeartIconProps = {
    className?: string;
    isFilled?: boolean;
    animateHeartBeat?: boolean;
    darkTheme?: boolean;
};

const LikeHeartIcon: FC<LikeHeartIconProps> = ({
    className,
    animateHeartBeat,
    isFilled,
    darkTheme,
}) => {
    const iconClasses = classnames(className, styles.likeIcon, {
        [styles.showHeartBeat]: animateHeartBeat,
        [styles.isFilled]: isFilled,
        [styles.darkTheme]: darkTheme,
    });
    return <HeartFilled className={iconClasses} />;
};
export default LikeHeartIcon;
